module.exports = __webpack_public_path__ + "img/09.3abada2d.jpg";